// extracted by mini-css-extract-plugin
export default {"articleViewer":"M9Gf9r","chatbotArticleFull":"Skei7j","chatbotArticlePreview":"LbQKfd"};